import * as React from "react";
import {IconButton, useTheme} from "@mui/material";
import {LinkOutlined} from "@ant-design/icons";

interface LinkButtonProps {
    href: string;
    title: string;
}
export default (props: LinkButtonProps) => {
    return (
        <IconButton
            color="primary"
            sx={{p: 0}}
            href={props.href}
            title={props.title}
            size='small'
            aria-label="View in JIRA">
            <LinkOutlined />
        </IconButton>
    )

}